import React from "react";
import { Link } from "react-router-dom";
import { contactLink, primaryNav } from "../data/navigation";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-gray-300 mt-auto">
            <div className="max-w-7xl mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Manufacturing Automation Group</h3>
                        <div className="space-y-2 text-sm">
                            <a
                                href="mailto:solutions@mag-automate.com"
                                className="block hover:text-white transition-colors duration-200"
                            >
                                solutions@mag-automate.com
                            </a>
                            <p className="text-gray-400">35572 Veronica St, Livonia, MI 48150</p>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2 text-sm">
                            {primaryNav.map((item) => (
                                <li key={item.to}>
                                    <Link to={item.to} className="hover:text-white transition-colors duration-200" discover="none">
                                        {item.label}
                                    </Link>
                                    {item.children?.length ? (
                                        <ul className="mt-2 space-y-2 pl-3">
                                            {item.children.map((child) => (
                                                <li key={child.to}>
                                                    <Link to={child.to} className="text-gray-400 hover:text-white transition-colors duration-200" discover="none">
                                                        {child.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : null}
                                </li>
                            ))}
                            <li>
                                <Link to={contactLink.to} className="hover:text-white transition-colors duration-200" discover="none">
                                    {contactLink.label}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Social */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Connect</h3>
                        <div className="flex items-center gap-4">
                            <a
                                href="https://www.linkedin.com/company/mag-automate/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-white transition-colors duration-200"
                                aria-label="LinkedIn"
                            >
                                <svg
                                    className="w-6 h-6"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Additional Info */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Company</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link to="/careers" className="hover:text-white transition-colors duration-200" discover="none">
                                    Careers
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms-of-service" className="hover:text-white transition-colors duration-200" discover="none">
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="/MAG-Privacy-Policy.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors duration-200"
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/docs/visitor-waiver"
                                    className="hover:text-white transition-colors duration-200"
                                    discover="none"
                                >
                                    Visitor check-in & waiver
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-800 pt-8 text-sm text-center text-gray-400">
                    <p>{`© ${currentYear} Manufacturing Automation Group LLC. All Rights Reserved.`}</p>
                </div>
            </div>
        </footer>
    );
}